var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import UserContactForm from '@declaration/components/appointment/UserContactForm.vue';
const claim = namespace('claim');
const settings = namespace('settings');
let DIContactOwner = class DIContactOwner extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/pause-parcours.svg');
        this.isUpdatingClaim = false;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    async nextStep() {
        await this.updateAndSaveClaimStep(this.currentStep);
    }
};
__decorate([
    claim.Action('updateAndSaveClaim')
], DIContactOwner.prototype, "updateAndSaveClaim", void 0);
__decorate([
    claim.Getter('currentStep')
], DIContactOwner.prototype, "currentStep", void 0);
__decorate([
    claim.Action('updateAndSaveClaimStep')
], DIContactOwner.prototype, "updateAndSaveClaimStep", void 0);
__decorate([
    settings.Getter('setting')
], DIContactOwner.prototype, "setting", void 0);
DIContactOwner = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
            UserContactForm,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], DIContactOwner);
export default DIContactOwner;
